import { ConnectionConfigDetails } from 'src/app/modules/platform/sources/source-modal/source-modal.component';

export interface ConnectionType {
    connectionType: string;
    description: string;
    updatedTime: Date;
    updatedUser: string;
    configJson: ConnectionConfigDetails[] | null;
    connectionFamily: ConnectionFamilyType | null;
    isSupported: boolean;
    supportedIrtTypes: IrtTypes[] | null;
}

export enum ConnectionFamilyType {
    relational = 'Relational',
    file = 'File'
}

export enum IrtTypes {
    SelfHosted = 'SelfHosted',
    AutoResolve = 'AutoResolveIntegrationRuntime',
    VirtualNetwork = 'ManagedVirtualNetwork'
}
